import "mapbox-gl/dist/mapbox-gl.css"
import "../styles/Various.css"

import React, { useEffect, useRef } from "react"
import {
  faAt,
  faEnvelope,
  faExternalLinkAlt,
  faPhone,
} from "@fortawesome/free-solid-svg-icons"
import {
  faFacebook,
  faLinkedin,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Helmet } from "react-helmet-async"
import mapboxgl from "mapbox-gl"

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN

const Contatti = () => {
  const mapContainer = useRef()
  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [11.131758, 43.687342],
      zoom: 18,
    })
    new mapboxgl.Marker().setLngLat([11.131758, 43.687342]).addTo(map)
    map.addControl(new mapboxgl.NavigationControl())
    document.title = "Contatti"
    return () => map.remove()
  }, [])
  return (
    <div className="Contatti">
      <Helmet>
        <meta
          name="description"
          content="Contatta iris strategia per l'ambiente sas, puoi inviarci una mail o telefonarci, o raggiungerci di persona nella nostra sede su appuntamento"
        />
        <link
          href="https://api.mapbox.com/mapbox-gl-js/v2.1.1/mapbox-gl.css"
          rel="stylesheet"
        />
      </Helmet>
      <div className="row">
        <div className="col-md-6">
          <h1>Contatti</h1>
          <h3 className="pt-4">IRIS Strategie per l'Ambiente sas</h3>
          <div className="pt-3">
            <strong>Sede legale e operativa:</strong>
            <br />
            Via Napoli 43 - 50026 Cerbaia, San Casciano in Val di Pesa (FI)
            <br />
            <br />
            <strong>Seconda sede operativa:</strong>
            <br />
            Via Bernini 5 - 50127 San Carlo, San Vincenzo (LI)
            <br />
            <br />
            <FontAwesomeIcon icon={faEnvelope} className="me-2" />
            <a
              href="mailto:iris@irisambiente.it"
              target="_blank"
              rel="noopener"
            >
              iris@irisambiente.it
            </a>
            <br />
            <FontAwesomeIcon icon={faAt} className="me-2" />
            <a
              href="mailto:irisambiente@pcert.postecert.it"
              target="_blank"
              rel="noopener"
            >
              irisambiente@pcert.postecert.it
            </a>
            <br />
            <FontAwesomeIcon icon={faPhone} className="me-2" />
            <a href="tel:+393357123458">
              <span>+39 3357123458</span>
            </a>
            <br />
            <FontAwesomeIcon icon={faWhatsapp} className="me-1" />
            <a
              href="https://wa.me/3703524036"
              target="_blank"
              rel="noopener noreferrer"
            >
              +39 3703524036
            </a>
            <br />
            <div className="mt-1">
              <a
                href="https://www.facebook.com/pages/category/Local-Business/IRIS-Ambiente-380072679828/"
                target="_blank"
                rel="noopener"
              >
                <FontAwesomeIcon icon={faFacebook} className="me-2" />
              </a>
              <a
                href="https://www.linkedin.com/company/iris-ambiente-sas/about/"
                target="_blank"
                rel="noopener"
              >
                <FontAwesomeIcon icon={faLinkedin} className="social" />
              </a>
            </div>
          </div>
          <div className="my-4">
            <hr />
          </div>
          <p>
            <strong>Per raggiungerci con i mezzi pubblici</strong>
          </p>
          <p>
            Da Firenze, vicino alla stazione FS di Santa Maria Novella prendere
            l’autobus della SITA n. 37: linea Firenze – Montespertoli – Certaldo
            e scendere alla prima fermata di Cerbaia, Cerbaia di Sopra (dopo
            circa 40 minuti).
          </p>
          <a
            href="https://www.at-bus.it/it/linee-e-orari/empoli-extraurbano-373"
            target="_blank"
            rel="noopener"
          >
            Orario autobus <FontAwesomeIcon icon={faExternalLinkAlt} />
          </a>
        </div>
        <div className="col-md-6 pt-md-0 pt-4">
          <div className="map-container rounded" ref={mapContainer} />
        </div>
      </div>
    </div>
  )
}

export default Contatti
